import aes from 'aes-js';

function normalizeKeyTo32Bytes(keyStr) {
    const keyBytes = aes.utils.utf8.toBytes(keyStr);
    if (keyBytes.length > 32) return keyBytes.slice(0, 32);
    while (keyBytes.length < 32) keyBytes.push(0);
    return keyBytes;
}

export function encryptAES256(plaintext, plainKey) {
    const key = normalizeKeyTo32Bytes(plainKey);
    const textBytes = aes.utils.utf8.toBytes(plaintext);
    const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(5));
    const encryptedBytes = aesCtr.encrypt(textBytes);
    return aes.utils.hex.fromBytes(encryptedBytes);
}

export function decryptAES256(encryptedHex, plainKey) {
    const key = normalizeKeyTo32Bytes(plainKey);
    const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(5));
    const encryptedBytes = aes.utils.hex.toBytes(encryptedHex);
    const decryptedBytes = aesCtr.decrypt(encryptedBytes);
    return aes.utils.utf8.fromBytes(decryptedBytes);
}

export function generateRandomKeyForAES256(length = 32) {
    const charset = '(0126#$789abcdefg345hijk%^rstuyABCD&*EFGHlmnopqIJKLMNOP!@)';
    let randomKey = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        randomKey += charset[randomIndex];
    }
    return randomKey;
}
